import { MarketableProductName } from './dto/marketableProduct';

export const APP_ELEMENT_ID = 'rhvklso002-root';
export const DEFAULT_PRODUCT_CARD_URL =
  '/henkiloasiakkaat/vakuutukset/henkilovakuutus/henkivakuutus';
export const CRITICAL_ILLNESS_PRODUCT_CARD_URL =
  '/henkiloasiakkaat/vakuutukset/henkilovakuutus/henkivakuutus/vakavan-sairauden-vakuutus';
export const DISABILITY_PRODUCT_CARD_URL =
  '/henkiloasiakkaat/vakuutukset/henkilovakuutus/henkivakuutus/tyokyvyttomyysvakuutus';

export const MOBILE_PRODUCT_CARD_URL =
  '/auth/vakuutukset/osta-op-henkivakuutus/henkivakuutus-mobiili';
export const MOBILE_DISABILITY_PRODUCT_CARD_URL =
  '/auth/vakuutukset/osta-op-henkivakuutus/tyokyvyttomyysvakuutus-mobiili';
export const MOBILE_CRITICAL_ILLNESS_PRODUCT_CARD_URL =
  '/auth/vakuutukset/osta-op-henkivakuutus/vakava-sairaus-mobiili';

export const PRODUCT_CARD_URLS: Record<
  string,
  { web: string; mobile: string }
> = {
  [MarketableProductName.INDIVIDUAL_LIFE]: {
    web: DEFAULT_PRODUCT_CARD_URL,
    mobile: MOBILE_PRODUCT_CARD_URL,
  },
  [MarketableProductName.INDIVIDUAL_CI]: {
    web: CRITICAL_ILLNESS_PRODUCT_CARD_URL,
    mobile: MOBILE_CRITICAL_ILLNESS_PRODUCT_CARD_URL,
  },
  [MarketableProductName.INDIVIDUAL_DISABILITY_ALL]: {
    web: DISABILITY_PRODUCT_CARD_URL,
    mobile: MOBILE_DISABILITY_PRODUCT_CARD_URL,
  },
};

export const DEBOUNCE_DELAY = 500;
